import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { createInvitation } from '@/api/invitations/invitationsApi';
import type {
  CreateInvitationPayload,
  InvitationWithLink,
} from '@/api/invitations/invitationsApi.types';
import { INVITATIONS_QUERY_KEY } from '@/constants/queryKeys';

export function useCreateInvitationMutation(): UseMutationResult<
  InvitationWithLink,
  Error,
  CreateInvitationPayload
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createInvitation,
    onSuccess: function invalidateInvitations() {
      queryClient.invalidateQueries({ queryKey: INVITATIONS_QUERY_KEY });
    },
  });
}
